import {Tooltip} from '@mui/material'
import {Box, Typography} from '@viptech/react-components'
import {WebSocketStatusesEnum} from 'src/hooks/api/socket/useWebsocket'
import usePersonalizedThemeByCompany from 'src/hooks/usePersonalizedThemeByCompany'
import liveIcon from 'src/images/liveIcon.gif'
import reconnectingIcon from 'src/images/reconnectingIcon.svg'
import ResumeIcone from 'src/images/ResumeIcon'
import styled, {keyframes} from 'styled-components'
import {useWindowSize} from 'usehooks-ts'

type Props = {
  status: WebSocketStatusesEnum
  onPressBackToLive: () => void
  onPressDisconnect: () => void
}

export default function WebSocketStatus({status, onPressBackToLive, onPressDisconnect}: Props) {
  const {styledTheme} = usePersonalizedThemeByCompany()
  const {width} = useWindowSize()

  const mobileWidth = width <= 767

  function getStatusComponents() {
    if (status === WebSocketStatusesEnum.CONNECTED) return {icon: <img src={liveIcon} width={20} height={20} alt='Ícone' />, color: '#F04438', text: 'Ao vivo'}
    else if (status === WebSocketStatusesEnum.RECONNECTING)
      return {
        icon: <SpinIcon src={reconnectingIcon} width={16} height={16} alt='Ícone' />,
        color: '#DC6803',
        text: 'Buscando conexão',
      }
    return {icon: <ResumeIcone />, color: styledTheme.colors.primary, text: 'Ver ao vivo'}
  }
  return (
    <Tooltip PopperProps={{popperOptions: {placement: 'left'}}} title={status === WebSocketStatusesEnum.DISCONNECTED ? 'Ver ao vivo' : 'Pausar ao vivo'}>
      <Box
        display='flex'
        columnGap='6px'
        marginRight='24px'
        align='center'
        onClick={() => {
          if (status === WebSocketStatusesEnum.DISCONNECTED) onPressBackToLive()
          else onPressDisconnect()
        }}
        style={{cursor: 'pointer'}}>
        {getStatusComponents().icon}

        {!mobileWidth && (
          <Typography
            variant='label'
            color={getStatusComponents().color}
            size='14px'
            weight={500}
            textDecoration={status === WebSocketStatusesEnum.DISCONNECTED ? 'underline' : 'none'}
            style={{cursor: 'pointer', textWrap: 'nowrap'}}>
            {getStatusComponents().text}
          </Typography>
        )}
      </Box>
    </Tooltip>
  )
}

const spin = keyframes`
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
`

const SpinIcon = styled.img`
  animation: ${spin} 2s linear infinite;
`
